<template lang="pug" src="./adminEditor.pug"></template>
<style lang="scss" src="./adminEditor.scss" scoped></style>

<script>
import { mapState, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import validate from '@/mixins/validate'
import { required, email } from 'vuelidate/lib/validators'
import { vLength } from '../../utils/helpers'
export default {
    mixins: [validate, validationMixin],
    data: () => ({
        accountInfo: {
            firstName: null,
            lastName: null,
            email: null,
            phoneNumber: null,
            cardNumber: null,
            passportNumber: null,
            taxId: null
        },
        role: null,
        canSaveChanges: false
    }),
    validations: {
        accountInfo: {
            firstName: {
                required
            },
            lastName: {
                required
            },
            taxId: {
                required,
                length: function() {
                    return vLength(10)(this.accountInfo.taxId)
                }
            },
            phoneNumber: {
                required,
                length: function() {
                    return vLength(9)(this.accountInfo.phoneNumber)
                }
            },
            cardNumber: {
                required,
                length: function() {
                    return vLength(16)(this.accountInfo.cardNumber)
                }
            },
            email: {
                required,
                email
            },
            passportNumber: {
                required
            }
        }
    },
    computed: {
        ...mapGetters(['type', 'permissions']),
        ...mapState({
            activeAdmin: state => state.admin.activeAdmin,
            rolesList: state => state.roles.rolesList
        })
    },
    watch: {
        accountInfo: {
            handler() {
                this.canSaveChanges = true
            },
            deep: true
        },
        role: {
            handler() {
                this.canSaveChanges = true
            },
            deep: true
        }
    },
    created() {
        if (this.$route.params.id) {
            this.loadData()
        }
        this.$store.dispatch('roles/getRolesList')
    },
    methods: {
        async loadData() {
            const adminId = this.$route.params.id
            await this.$store.dispatch('admin/getAdminById', adminId).then(data => {
                this.accountInfo = Object.assign({},
                    Object.select(data, ['id', ...Object.keys(this.accountInfo)]), {
                        phoneNumber: data.phoneNumber && data.phoneNumber.replace(/^\+?380/, '')
                    }
                )

                this.role = Object.assign({}, this.role, {
                    ...data.role
                })

                this.$nextTick(() => {
                    this.canSaveChanges = false
                })
            })
        },

        onRoleChange(data) {
            this.role = data
        },

        async saveChanges() {
            if (this.$v.accountInfo.$invalid) {
                this.$v.accountInfo.$touch()
            } else {
                await this.$store.dispatch('admin/updateAdmin', {
                    ...this.accountInfo,
                    roleId: this.role.id,
                    phoneNumber: this.accountInfo.phoneNumber && `+380${this.accountInfo.phoneNumber}`
                })

                this.$nextTick(() => {
                    this.canSaveChanges = false
                    this.$v.accountInfo.$reset()
                })
            }
        }
    }
}
</script>

